<div (click)="activation()" class="btn button-activate">
    <i class="icon icon-card-fill"></i>
    <i class="btn-text">{{'BTN_ACTIVATE.LABEL' | translate}}</i>
</div>
